import type { ReactNode } from 'react';

export const symbol_edit_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-244q-13 0-21.5-8.5T120-274v-99q0-12 5-23.5t13-19.5l291-292q18-18 43-18t42 18l68 69q17 17 17 42t-17 42L291-262q-8 8-19.5 13t-23.5 5h-98Zm30-60h69l178-181-34-34-34-34-179 179v70Zm291-223-68-69 68 69Zm299 346-87-87q-9-9-9-21t9-21q9-9 21-9t21 9l36 36v-496q0-13 8.5-21t21.5-8q13 0 21.5 8.5T821-769v496l37-37q9-9 21-9t21 9q9 9 9 21t-9 21l-87 87q-9 9-21.5 9t-21.5-9Z"
		/>
	</svg>
);
